import { render, staticRenderFns } from "./OneTrustCookieSettings.vue?vue&type=template&id=7c8fca62&scoped=true&"
import script from "./OneTrustCookieSettings.vue?vue&type=script&lang=js&"
export * from "./OneTrustCookieSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8fca62",
  null
  
)

export default component.exports